<script setup>

import PathLockInfo from "@/components/list/PathLockInfo";
import ItemImage from "@/components/list/ContentListItemImage";
import ItemTitle from "@/components/list/ContentListItemTitle";
import ItemButton from "@/components/list/ContentListItemButton";
import ItemDescription from "@/components/list/ContentListItemDescription";
import ItemDetails from "@/components/list/ContentListItemDetails";
import ItemStatus from "@/components/list/ContentListItemStatus";
import ItemProgress from "@/components/list/ContentListItemProgress";
import ItemButtonMobile from "@/components/list/ContentListItemMobileButton";

import {computed, defineProps, ref} from "vue";

const isActive = ref(false);
const props = defineProps({
    content: Object,
    index: Number,
})

const isDisabled = computed(() => {
    return isActive.value || props.content.locked;
});

</script>

<template>
    <PathLockInfo v-if="props.content.locked" :content="props.content" :index="props.index"/>
    <div class="lg:grid drop-shadow-md my-4 max-h-max grid-cols-9 gap-x-7 rounded-xl bg-white p-6">
        <div class="col-span-3 flex flex-col">
            <ItemImage :content="content"/>
        </div>
        <div class="col-span-6">
            <div class="title lg:flex items-start justify-between">
                <ItemTitle :content="content"/>
                <ItemButton :disabled="isDisabled" :content="content" :index="index"/>
            </div>
            <ItemDescription :content="content"/>
            <div class="mt-4">
                <ItemDetails :content="content"/>
                <ItemStatus :content="content"/>
                <ItemProgress :content="content" :index="index"/>
            </div>
        </div>
        <ItemButtonMobile :disabled="isDisabled" :content="content" :index="index"/>
    </div>
</template>
